import { useLinkTo } from '../../../../../hooks';
import { toSlugCase } from '../../../../../modules/stringUtils';
import { SEARCH_ROUTE } from '../../../../../route-names';

export type ServiceSearchRequest = {
  city: string;
  state: string;
  searchTerm: string;
};

export default function useGoToSearch() {
  const linkTo = useLinkTo();

  return (source: string, searchRequest: ServiceSearchRequest) => {
    linkTo(SEARCH_ROUTE, {
      source,
      q: toSlugCase(searchRequest.searchTerm),
      loc: `${toSlugCase(searchRequest.city)}-${toSlugCase(searchRequest.state)}`,
    });
  };
}
